import { render, staticRenderFns } from "./storeImport.vue?vue&type=template&id=0ddcea04&scoped=true&"
import script from "./storeImport.vue?vue&type=script&lang=js&"
export * from "./storeImport.vue?vue&type=script&lang=js&"
import style0 from "./storeImport.vue?vue&type=style&index=0&id=0ddcea04&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddcea04",
  null
  
)

export default component.exports